import { AppState } from '../../common/configuration/app.states';

export const getAllPatients = (state: AppState) => state.patients.patients;

export const getNotes = (state: AppState) => state.patients.notes;

export const getAllTreatmentsAntecedents = (state: AppState) => state.patients.treatmentsAntecedents;
